import { CoreInfoRequestReasonTypeEnum } from "../Enums/CoreInfoRequestReasonTypeEnum";
import ExperienceNoteTypes from "../Enums/ExperienceNoteType";
export const DefaultCreatedDateSort = { field: "createdDate", order: "DESC" };

export const DefaultRequestDateSort = { field: "requestDate", order: "DESC" };

export const DefaultIsActiveFilter = { isActive__eq: true };

export const DefaultPhaseOutFilter = { phaseOut__eq: false };

export const DefaultPerPageSize = 25;

export const DefaultRowsPerPageOptions = [5, 10, 25, 50, 75, 100];

export const PeriodMonths = [
  { month: "JANUARY", value: 1 },
  { month: "FEBRUARY", value: 2 },
  { month: "MARCH", value: 3 },
  { month: "APRIL", value: 4 },
  { month: "MAY", value: 5 },
  { month: "JUNE", value: 6 },
  { month: "JULY", value: 7 },
  { month: "AUGUST", value: 8 },
  { month: "SEPTEMBER", value: 9 },
  { month: "OCTOBER", value: 10 },
  { month: "NOVEMBER", value: 11 },
  { month: "DECEMBER", value: 12 },
];

export const QuarantineLocations = [
  { locations: "SAW", value: "SAW" },
  { locations: "İSL", value: "İSL" },
  { locations: "İST", value: "İST" },
];

export const QuarantineUnitType = [
  { unitTypes: "Serviceable", value: "Serviceable" },
  { unitTypes: "Core Unit", value: "Unserviceable" },
  { unitTypes: "No Information", value: "No Information" },
];

export const ServiceableTransactionTypeKey = "RN/RECEIVING";

export const WorkShops = [
  { shop: "HYDRAULIC SHOP", value: "HYDRAULIC SHOP" },
  { shop: "MECHANICAL SHOP", value: "MECHANICAL SHOP" },
  { shop: "ELECTMEC", value: "ELECTMEC" },
  { shop: "SANITARY SHOP", value: "SANITARY SHOP" },
  { shop: "IFE COMPONENT SHOP", value: "IFE COMPONENT SHOP" },
  { shop: "SANITARY", value: "SANITARY" },
  { shop: "IFE", value: "IFE" },
  { shop: "ELECTROMECHANIC SHOP", value: "ELECTROMECHANIC SHOP" },
  { shop: "PNEUMATC", value: "PNEUMATC" },
  { shop: "ELECTRICAL SHOP", value: "ELECTRICAL SHOP" },
  { shop: "COMPRESSED GAS CYLINDER&REGULATOR-OXYGEN-SHOP", value: "COMPRESSED GAS CYLINDER&REGULATOR-OXYGEN-SHOP" },
  { shop: "HYDRAUL", value: "HYDRAUL" },
  { shop: "INSTRMNT", value: "INSTRMNT" },
  { shop: "PNEUMATIC SHOP", value: "PNEUMATIC SHOP" },
  { shop: "RADIO", value: "RADIO" },
  { shop: "SEAT", value: "SEAT" },
  { shop: "IDG & GENERATOR SHOP", value: "IDG & GENERATOR SHOP" },
  { shop: "RADIO SHOP", value: "RADIO SHOP" },
  { shop: "MECHANIC", value: "MECHANIC" },
  { shop: "ATE", value: "ATE" },
  { shop: "ATE SHOP", value: "ATE SHOP" },
  { shop: "ELECTRIC", value: "ELECTRIC" },
  { shop: "FUEL COMPONENT SHOP", value: "FUEL COMPONENT SHOP" },
  { shop: "INSTRUMENTS SHOP", value: "INSTRUMENTS SHOP" },
];

export const WoStatus = [
  { woStatus: "TOOLREP", value: "TOOLREP" },
  { woStatus: "WAITPART", value: "WAITPART" },
  { woStatus: "WAITCAP", value: "WAITCAP" },
  { woStatus: "-NDT", value: "-NDT" },
  { woStatus: "-PLATING", value: "-PLATING" },
  { woStatus: "WAIT_EO", value: "WAIT_EO" },
  { woStatus: "ABROAD", value: "ABROAD" },
  { woStatus: "IN_US_BIN", value: "IN_US_BIN" },
  { woStatus: "DOCUMENT", value: "DOCUMENT" },
  { woStatus: "-WELDING", value: "-WELDING" },
  { woStatus: "IN_PROGRES", value: "IN_PROGRES" },
  { woStatus: "ON_HOLD", value: "ON_HOLD" },
  { woStatus: "CSTMR_WAIT", value: "CSTMR_WAIT" },
  { woStatus: "TOOLFABRIC", value: "TOOLFABRIC" },
  { woStatus: "-SPEC_PROC", value: "-SPEC_PROC" },
  { woStatus: "-MACHINING", value: "-MACHINING" },
  { woStatus: "WAIT_BENCH", value: "WAIT_BENCH" },
  { woStatus: "WAIT_CHEM", value: "WAIT_CHEM" },
  { woStatus: "OTHERSHOP", value: "OTHERSHOP" },
  { woStatus: "CONCESSION", value: "CONCESSION" },
  { woStatus: "e52579", value: "e52579" },
  { woStatus: "WAITREP", value: "WAITREP" },
  { woStatus: "BENCHFAIL", value: "BENCHFAIL" },
  { woStatus: "PARTFABRIC", value: "PARTFABRIC" },
  { woStatus: "SCRAP", value: "SCRAP" },
  { woStatus: "SCRAP CAND", value: "SCRAP CAND" },
  { woStatus: "CSTMR APRV", value: "CSTMR APRV" },
  { woStatus: "WAITTOOL", value: "WAITTOOL" },
  { woStatus: "CAP_INPROG", value: "CAP_INPROG" },
  { woStatus: "TOOL_CALIB", value: "TOOL_CALIB" },
  { woStatus: "WAIT_RELEA", value: "WAIT_RELEA" },
];

export const ServiceableStatus = [
  { status: "Accepted", value: "Accepted" },
  { status: "Rejected", value: "Rejected" },
  { status: "N/A", value: "N/A" },
];

export const ExperienceNoteType = [
  { noteType: "Info", value: ExperienceNoteTypes.Info },
  { noteType: "Serviceable", value: ExperienceNoteTypes.Serviceable },
  { noteType: "Core Unit", value: ExperienceNoteTypes.Unserviceable },
  { noteType: "Shop", value: ExperienceNoteTypes.Shop },
];

export const CoreInfoRequestReasonType = [
  { reasonType: "TSI", value: CoreInfoRequestReasonTypeEnum.Tsi },
  { reasonType: "TSO", value: CoreInfoRequestReasonTypeEnum.Tso },
  { reasonType: "TSR", value: CoreInfoRequestReasonTypeEnum.Tsr },
  { reasonType: "TSN", value: CoreInfoRequestReasonTypeEnum.Tsn },
  { reasonType: "CSI", value: CoreInfoRequestReasonTypeEnum.Csi },
  { reasonType: "CSO", value: CoreInfoRequestReasonTypeEnum.Cso },
  { reasonType: "CSR", value: CoreInfoRequestReasonTypeEnum.Csr },
  { reasonType: "CSN", value: CoreInfoRequestReasonTypeEnum.Csn },
  { reasonType: "DSI", value: CoreInfoRequestReasonTypeEnum.Dsi },
  { reasonType: "DSO", value: CoreInfoRequestReasonTypeEnum.Dso },
  { reasonType: "DSR", value: CoreInfoRequestReasonTypeEnum.Dsr },
  { reasonType: "DSN", value: CoreInfoRequestReasonTypeEnum.Dsn },
  { reasonType: "NEW F1", value: CoreInfoRequestReasonTypeEnum.NewF1, isFileType: true },
  { reasonType: "DETAILED REMOVAL REASON", value: CoreInfoRequestReasonTypeEnum.DetailedRemovalReason },
  { reasonType: "NIS", value: CoreInfoRequestReasonTypeEnum.Nis, isFileType: true },
  { reasonType: "PFR", value: CoreInfoRequestReasonTypeEnum.Pfr, isFileType: true },
  { reasonType: "ARL", value: CoreInfoRequestReasonTypeEnum.Arl, isFileType: true },
  { reasonType: "IPC CMM", value: CoreInfoRequestReasonTypeEnum.IpcCmm, isFileType: true },
  { reasonType: "WARRANTY REF", value: CoreInfoRequestReasonTypeEnum.WarrantyRef, isFileType: true },
  { reasonType: "DOM", value: CoreInfoRequestReasonTypeEnum.Dom },
  { reasonType: "UNUSED STATEMENT", value: CoreInfoRequestReasonTypeEnum.UnusedStatement, isFileType: true },
  { reasonType: "NHA", value: CoreInfoRequestReasonTypeEnum.Nha },
  { reasonType: "NLA", value: CoreInfoRequestReasonTypeEnum.Nla },
  { reasonType: "LAST SHOP REPORT", value: CoreInfoRequestReasonTypeEnum.LastShopReport, isFileType: true },
  { reasonType: "US TAG", value: CoreInfoRequestReasonTypeEnum.UsTag, isFileType: true },
  { reasonType: "LAST TEST CERT", value: CoreInfoRequestReasonTypeEnum.LastTestCertification, isFileType: true },
  { reasonType: "SHIPPING INVOICE", value: CoreInfoRequestReasonTypeEnum.ShippingInvoice, isFileType: true },
  { reasonType: "PACKING SLIP", value: CoreInfoRequestReasonTypeEnum.PackingSlip, isFileType: true },
  { reasonType: "AD SB MOD", value: CoreInfoRequestReasonTypeEnum.AdSbMod },
  { reasonType: "LAST OH CERT", value: CoreInfoRequestReasonTypeEnum.LastOhCertification, isFileType: true },
  { reasonType: "LAST REPAIR CERT", value: CoreInfoRequestReasonTypeEnum.LastRepairCertification, isFileType: true },
  { reasonType: "TSN & CSN STATEMENT", value: CoreInfoRequestReasonTypeEnum.TsnAndCsnStatement, isFileType: true },
  { reasonType: "PN & SN STATEMENT", value: CoreInfoRequestReasonTypeEnum.PnAndSnStatement, isFileType: true },
  { reasonType: "MAINTENANCE RECORD", value: CoreInfoRequestReasonTypeEnum.MaintenanceRecord, isFileType: true },
  { reasonType: "BACK TO BIRTH", value: CoreInfoRequestReasonTypeEnum.BackToBirth, isFileType: true },
  { reasonType: "ENGINE SERIAL NUMBER", value: CoreInfoRequestReasonTypeEnum.EngineSerialNumber },
];

export const PbhUnserviceableReplenishmentType = [
  { replenishmentTypes: "Rejection", value: 0 },
  { replenishmentTypes: "Fail on Fit / Premature Failure", value: 1 },
  { replenishmentTypes: "Serviceable Return", value: 2 },
];

export const ThyFleetTypes = [
  { type: "NG", value: "NG" },
  { type: "MAX", value: "MAX" },
  { type: "NEO", value: "NEO" },
  { type: "CEO", value: "CEO" },
  { type: "A330", value: "A330" },
  { type: "B777", value: "B777" },
  { type: "B787", value: "B787" },
  { type: "A350", value: "A350" },
  { type: "A340", value: "A340" },
  { type: "B747", value: "B747" },
  { type: "OTHER", value: "OTHER" },
];

export const FileAcceptWhiteList: string =
  ".txt, .pdf, .png, .jpg, .jpeg, .docx, .xlsx, .doc, .xls, .msg,application/vnd.ms-outlook";
